import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IRunVetComplianceScriptPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useRunScriptVetCompliance() {
  const runScriptVetCompliance = useCallback(
    (payload: IRunVetComplianceScriptPayload) =>
      AiWorkspaceService.runScriptVetCompliance(payload)
        .then((res) => {
          ToastService.success("Script check started");
          return res;
        })
        .catch(async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to run script check")
          );
          throw err;
        }),
    []
  );

  const {
    mutate: run,
    isLoading: isRunning,
    isSuccess: hasRun,
  } = useMutation<IRunVetComplianceScriptPayload>({
    mutationFn: runScriptVetCompliance,
    options: QUERY_OPTIONS,
    onSuccess: (queryClient, _data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          AI_WORKSPACE_QUERY_KEYS.REQUEST,
          variables.aiWorkspaceRequestId,
        ],
      });
    },
  });

  return { run, isRunning, hasRun };
}
